import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "relative w-36" }
const _hoisted_2 = { class: "block truncate" }
const _hoisted_3 = { class: "absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: /*#__PURE__*/_normalizeClass(['font-normal', 'block truncate'])
}, " Select All ", -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  class: /*#__PURE__*/_normalizeClass(['font-normal', 'block truncate'])
}, " Select None ", -1 /* HOISTED */)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "py-1 px-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "block h-px bg-gray-400" })
], -1 /* HOISTED */)
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChevronUpDownIcon = _resolveComponent("ChevronUpDownIcon")!
  const _component_ListboxButton = _resolveComponent("ListboxButton")!
  const _component_CheckIcon = _resolveComponent("CheckIcon")!
  const _component_ListboxOption = _resolveComponent("ListboxOption")!
  const _component_XMarkIcon = _resolveComponent("XMarkIcon")!
  const _component_ListboxOptions = _resolveComponent("ListboxOptions")!
  const _component_Listbox = _resolveComponent("Listbox")!

  return (_openBlock(), _createBlock(_component_Listbox, { as: "div" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_ListboxButton, { class: "relative w-full bg-black border border-black rounded-md shadow-sm pl-3 pr-10 py-1 text-left cursor-pointer focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.displayedLabel), 1 /* TEXT */),
            _createElementVNode("span", _hoisted_3, [
              _createVNode(_component_ChevronUpDownIcon, {
                class: "h-5 w-5 text-text-light",
                "aria-hidden": "true"
              })
            ])
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_Transition, {
          "leave-active-class": "transition ease-in duration-100",
          "leave-from-class": "opacity-100",
          "leave-to-class": "opacity-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ListboxOptions, { class: "absolute z-10 mt-1 w-full bg-black shadow-xl shadow-slate-600 max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm" }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_component_ListboxOption, {
                  as: "template",
                  key: '__ALL__',
                  value: '__ALL__'
                }, {
                  default: _withCtx(({active}) => [
                    _createElementVNode("li", {
                      class: _normalizeClass([
								active ? 'text-text-light bg-bg-light' : 'text-text-faded',
								'cursor-pointer select-none relative py-2 pl-8 pr-4',
							]),
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectAll && _ctx.selectAll(...args)))
                    }, [
                      _hoisted_4,
                      _createElementVNode("span", {
                        class: _normalizeClass([
									active ? 'text-text-light bg-bg-light' : 'text-text-faded',
									'absolute inset-y-0 left-0 flex items-center pl-1',
								])
                      }, [
                        _createVNode(_component_CheckIcon, {
                          class: "h-5 w-5 text-green-600",
                          "aria-hidden": "true"
                        })
                      ], 2 /* CLASS */)
                    ], 2 /* CLASS */)
                  ]),
                  _: 1 /* STABLE */
                })),
                (_openBlock(), _createBlock(_component_ListboxOption, {
                  as: "template",
                  key: '__NONE__',
                  value: '__NONE__'
                }, {
                  default: _withCtx(({active}) => [
                    _createElementVNode("li", {
                      class: _normalizeClass([
								active ? 'text-text-light bg-bg-light' : 'text-text-faded',
								'cursor-pointer select-none relative py-2 pl-8 pr-4',
							]),
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.selectNone && _ctx.selectNone(...args)))
                    }, [
                      _hoisted_5,
                      _createElementVNode("span", {
                        class: _normalizeClass([
									active ? 'text-text-light' : 'text-text-faded',
									'absolute inset-y-0 left-0 flex items-center pl-1',
								])
                      }, [
                        _createVNode(_component_XMarkIcon, {
                          class: "h-5 w-5 text-red-500",
                          "aria-hidden": "true"
                        })
                      ], 2 /* CLASS */)
                    ], 2 /* CLASS */)
                  ]),
                  _: 1 /* STABLE */
                })),
                _hoisted_6,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entries, (entry, i) => {
                  return (_openBlock(), _createBlock(_component_ListboxOption, {
                    as: "template",
                    key: i,
                    value: entry.value
                  }, {
                    default: _withCtx(({active}) => [
                      _createElementVNode("li", {
                        class: _normalizeClass([
								active ? 'text-text-light bg-bg-light' : 'text-text-faded',
								'cursor-pointer select-none relative py-2 pl-8 pr-4',
							]),
                        onClick: ($event: any) => (_ctx.toggleAttribute($event, entry))
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass([entry.selected ? 'font-semibold' : 'font-normal', 'block truncate'])
                        }, _toDisplayString(entry.name), 3 /* TEXT, CLASS */),
                        (entry.selected)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass([
									active ? 'text-white' : 'text-text-faded',
									'absolute inset-y-0 left-0 flex items-center pl-1',
								])
                            }, [
                              _createVNode(_component_CheckIcon, {
                                class: "h-5 w-5",
                                "aria-hidden": "true"
                              })
                            ], 2 /* CLASS */))
                          : _createCommentVNode("v-if", true)
                      ], 10 /* CLASS, PROPS */, _hoisted_7)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value"]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    _: 1 /* STABLE */
  }))
}